$(document).on('click','[scrollEventJSHandle]',function(evt){
  evt.preventDefault();
  const targetLink = $(this).attr('href'), includesHash = targetLink.includes('#');
  if(includesHash && !$('body').hasClass('index')){
    $('html, body').animate({
      scrollTop: $(targetLink).offset().top - 100
    }, 100);
  }
  if($('body').hasClass('index')){
    $('html, body').animate({
      scrollTop: $(targetLink).offset().top - 10
    }, 200);
  }
});

$(document).on('click','[menuTogglerJSHandle]',function(){
  if($(this).hasClass('hamburger')){
    $(this).addClass('close').removeClass('hamburger').siblings('[menutargetjshandle]').addClass('menuTagertHitted').slideDown();
  }else{
    $(this).addClass('hamburger').removeClass('close').siblings('[menutargetjshandle]').removeClass('menuTagertHitted').slideUp();
  }
})



// Header JS Start

// window.addEventListener('DOMContentLoaded', function(){
//   $.getJSON('https://geolocation-db.com/json/', function(data) {
//     if(data){
//       const cntry_name = document.body.querySelectorAll('.js-country-name'), cntry_flag = document.body.querySelectorAll('.js-country-flag');
//       data.country_code = data.country_code.toLowerCase();
//       cntry_name.forEach(function(e){ e.innerHTML = data.country_name }), cntry_flag.forEach(function(t){ t.innerHTML = '<img src="https://flagcdn.com/16x12/'+data.country_code+'.png" style="width:18px">'; })
//     }
//   });
// })

$(document).on('click','[togglerMenuJSHandle]',function(){
  $(this).toggleClass('toggleActive').siblings('[togglerMenuTarget]').toggle().parent('[parentTargetJSHandle]').siblings('[parentTargetJSHandle]').children('[togglerMenuJSHandle]').removeClass('toggleActive').siblings('[togglerMenuTarget]').hide();
})

$(document).on('click',function(e){
  if(!$(e.target).closest('.announce_main_link').length > 0){
    $('.togglerComponents').removeClass('toggleActive').siblings('.TOpBarCHLDLinks').hide();
  }
})

// Header JS extends

// Footer JS Start

setInterval(function(){
  const updates = document.querySelector('#check_letter'),
        formSubmit = document.querySelector('.footer-block__newsletter #Subscribe'),
        greetLength = document.querySelectorAll('.newsletter-form__message').length;
  if(greetLength == 0 && document.querySelectorAll('#check_letter').length){
    if(updates.checked == false){
      const appendSelector = document.querySelector('.checkbox_main_wrapper'),
            appendData = '<span class="data_error">!!Please Check the box before Submit</span>';
      formSubmit.setAttribute('disabled',true);
      document.querySelector('.data_error').classList.add('error_enable');
    }
    else{
      formSubmit.removeAttribute('disabled');
      document.querySelector('.data_error').classList.remove('error_enable');
    }
  }
},500)

// Footer JS End

// $(window).scroll(function() {
//  var scrollCount = 0, latestScrollTop = 0, doc = document.documentElement, top = 0;
// top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
//           if (latestScrollTop < top) { scrollCount += 1; } else { scrollCount -= 1; }
//           latestScrollTop = top;
//   if (top > 10) {
//     var iframe = $(".video-row__iframe-wrapper").attr('onadjust');
//      if($('.iframeJSAppendHandle').length == 0){ $(".video-row__iframe-wrapper").append(iframe); $(".video-row__iframe-wrapper").addClass('iframeJSAppendHandle'); }
//    console.log(iframe);
//   }
// });


$(document).ready(function() {
  
$(document).on('click','[name="accept_field"]',function(){
	if($(this).is(':checked')){
		document.cookie = 'popup_accepted=checked';
      setTimeout(function () {
        $('.pageloadPopup').removeClass("ByDeault");  
        }, 1000);
	}else{
		document.cookie = 'popup_accepted=false';
	}
});
   
   if($.cookie('popup_accepted') === 'checked'){
      $('.pageloadPopup').removeClass("ByDeault");  
      console.log('cookie-find');
  }else{
      console.log('undefined');
  }

    $(document).ready(function() {
    if(localStorage.getItem('popState') != 'shown'){
        $(".pageloadPopup").delay(30000).fadeIn();
        localStorage.setItem('popState','shown')
    }
    else {
    }

    $('.popupWrapContentHeader').click(function(e) // You are clicking the close button
    {
    $('.pageloadPopup').fadeOut(); // Now the pop up is hiden.
    });
    $('.pageloadPopup').click(function(e) 
    {
    $('.pageloadPopup').fadeOut(); 
    });
});


  
$(document).on('click','[name="checkout_field"]',function(){
	if($(this).is(':checked')){
		document.cookie = 'checkout_accepted=checked';
      setTimeout(function () {
         $('.Checkoutpopup').addClass('hide--second_popup');
          $('body').removeClass("OverlayWrapper"); 
        $('.pageloadPopup').removeClass("ByDeault");   
        }, 1000);
	}else{
		document.cookie = 'checkout_accepted=false';
	}

   if($.cookie('checkout_accepted') === 'checked'){
   window.location.href = '/checkout';
 }
});
  
   if($.cookie('checkout_accepted') === 'checked'){
     $('.Checkoutpopup').addClass('hide--second_popup');
      console.log('cookie-find');
  }else{
      console.log('undefined');
  }

  $(document).on('click', '.cart__checkout-button',function(e){
   e.preventDefault();
  $('.Checkoutpopup').addClass("checkout-popup"); 
  $('.Checkoutpopup').css('display', 'block'); 
     $('body').addClass("OverlayWrapper"); 
     if($.cookie('checkout_accepted') === 'checked'){
  window.location.href = '/checkout';;
  }
  })

  $(".popupWrapContentHeader").click(function () {
    $('.pageloadPopup').addClass("active");   
  $('.Checkoutpopup').addClass("active"); 
     $('.Checkoutpopup').css('display', 'none'); 
  $('.Checkoutpopup').removeClass('checkout-popup');
    $('body').removeClass("OverlayWrapper"); 
});

    $(document).on('click', '.Onclick_enlarged', function() {
    $('body').addClass('Zoomimage');
  });

  
 $(document).click(function (e) {
		if (!$(e.target).closest('.Onclick_enlarged').length) {
			$('body').removeClass('Zoomimage');
		}
    });

    $('.OnlyOneCheck').click(function() {
      var checked =  $('.OnlyOneCheck').not(this).prop('checked', false);
    });

// Faq Tabs Start
  
  if($('.faq-tabs-content').length > 0 && $('.faq-tabs-content').hasClass('active_tab')){
    $('.faq-tabs-content.active_tab').siblings().children('.tab-content').slideUp();
  }

    $(document).on('click','.tab-heading',function(e){e.preventDefault();
       $.when($(this).parents('.faq-tabs-content').toggleClass('active_tab').children('.tab-content').slideToggle().parent('.faq-tabs-content').siblings().removeClass('active_tab').children('.tab-content').slideUp()).then(function () {
       $('html, body').animate({scrollTop: $('.faq-tabs-content.active_tab').offset().top - 130 }, 500)})
  })


  // Faq Tabs End

})

 $(document).on('click', '.downloadlink',function(e){
  e.preventDefault();

    var pdflink = $(this).attr('href');
    $.ajax({
      url: pdflink,
      method: 'GET',
      xhrFields: {
        responseType: 'blob'
      },
      success: function (data) {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = 'TheFloralHandofGod.pdf';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    });
 
});



window.addEventListener('resize', function(event) {
	if (window.matchMedia("(max-width: 749px)").matches) {
		$('.features_block').slick({
		  infinite: true,
		  slidesToShow: 2,
		  slidesToScroll: 2,
		  arrows: true,
		});
    }
    else{
		$('.features_block').slick('unslick');
    }
 });

$(document).ready(function(){
  if (window.matchMedia("(max-width: 749px)").matches) {
		$('.features_block').slick({
		  infinite: true,
		  slidesToShow: 2,
		  slidesToScroll: 2,
		  arrows: true,
		});
    }
    else{
		$('.features_block').slick('unslick');
    }
})


// $(document).ready(function(){
//   var ip = 0;   
// var demoqtt = $('.Tagbased_discount').attr("Wpprice"); 
//   console.log(demoqtt);
//   var Pricecurrency = $('.Tagbased_discount').attr("curreny");
//    ip += +demoqtt;
//       var dect = (50 / 100).toFixed(2);
//     var multt = demoqtt * dect;
//     var discontt = ip - multt;
// $(".Tagbased_discount").html(Pricecurrency+ discontt/100+ " ");
// });


